
import hasContentMeta from '~/mixins/hasContentMeta'

export default {
    mixins: [hasContentMeta],

    props: {
        content: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    async fetch() {
        if (this.content.id)
            await this.$axios.$get(`/api/v1/content?id=${this.content.id}`).then((res) => {
                this.model = res.data
            })
    },

    data() {
        return {
            model: {},
        }
    },

    computed: {
        smDevice() {
            return this.$store.getters["data/smDevice"]
        },
        lgDevice() {
            return this.$store.getters["data/lgDevice"]
        },
        cover() {
            const cover = this.model.cover
                ? `${this.apiUrl}/1920/1080/${this.model.cover.id}`
                : this.images?.length
                ? `${this.apiUrl}/1920/1080/${this.images[0].cover.id}`
                : ''
            return `url(${cover || '/guest-list/Loverly_GuestListUserCover.jpg'})`
        },

        title() {
            return this.content.title || this.model.name
        },

        text() {
            return this.content.text || this.model.excerpt
        },

        apiUrl() {
            return process.env.apiUrl + '/api/v1/attachments'
        },
    },
}
